import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { BasicModal } from '../common/modals/BasicModal';
import BrowserUtils from '../../utils/BrowserUtils';

import { isBOrVMRetail } from '../../utils/BrandUtils';
import FaqAnyQuestionsLink from '../common/FaqAnyQuestionLinks';

class StatementPreferencesModal extends Component {
  constructor(props) {
    super(props);
    this._onContinueClick = this._onContinueClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getModalHeader = this.getModalHeader.bind(this);
  }

  getModalHeader() {
    return this.props.continueButtonClick
      ? this.props.content.updateStatementPreferencesModalHeader
      : this.props.content.statementPreferencesModalHeader;
  }

  _onContinueClick() {
    if (BrowserUtils.isMobileView()) {
      this.props._sendRequestPacket();
    } else {
      const deskScrollTop =
        this.refs.focusDiv.scrollHeight - this.refs.focusDiv.offsetHeight;
      if (
        Math.ceil(this.refs.focusDiv.scrollTop) === deskScrollTop ||
        Math.floor(this.refs.focusDiv.scrollTop) === deskScrollTop
      ) {
        this.props._sendRequestPacket();
      } else {
        ReactDOM.findDOMNode(this.refs.focusDiv).scrollTop = deskScrollTop;
      }
    }
  }

  closeModal() {
    this.props.helpModal(false);
  }

  render() {
    let displayButtons;
    let displayCancelButton;
    let desktopDisplayPage;
    let mobileDisplayPage;
    let agreementText;
    if (this.props.continueButtonClick) {
      agreementText = (
        <p>{this.props.content.statementPreferenceModalContent11}</p>
      );
      if (!BrowserUtils.isMobileView()) {
        displayButtons = (
          <div className="row no-gutters">
            <div className="col-sm-6 col-xs-6 text-center">
              <button
                className="c-btn c-btn--secondary"
                onClick={this.closeModal}
              >
                {this.props.content.cancelButton}
              </button>
            </div>
            <div className="col-sm-6 col-xs-6 text-center">
              <button
                className="c-btn c-btn--default"
                onClick={this._onContinueClick}
              >
                Continue
              </button>
            </div>
          </div>
        );
      } else {
        displayButtons = (
          <div>
            <button
              className="c-btn c-btn--default"
              onClick={this._onContinueClick}
            >
              Continue
            </button>
          </div>
        );
        displayCancelButton = (
          <div className="col-sm-2 col-xs-2 text-left">
            <button
              className="page-back"
              type="button"
              onClick={this.closeModal}
            >
              Back
            </button>
          </div>
        );
      }
    } else {
      agreementText = <p />;
      if (!BrowserUtils.isMobileView()) {
        displayButtons = (
          <button className="c-btn c-btn--default" onClick={this.closeModal}>
            {this.props.content.digitalModalButton}
          </button>
        );
        displayCancelButton = <div className="col-sm-2 col-xs-2" />;
      } else {
        displayButtons = (
          <button className="c-btn c-btn--default" onClick={this.closeModal}>
            {this.props.content.digitalModalButton}
          </button>
        );
        displayCancelButton = <div className="col-sm-2 col-xs-2" />;
      }
    }
    if (!BrowserUtils.isMobileView()) {
      desktopDisplayPage = (
        <BasicModal>
          <div className="modalb msg-popup digi-help-modal preference-modal">
            <div className="modalb-header">
              <h4>{this.getModalHeader()}</h4>
            </div>

            {this.props.continueButtonClick || isBOrVMRetail() ? (
              <div ref="focusDiv" className="modalb-container">
                <h5>{this.props.content.statementPrefernceModalHeader1}</h5>
                <ul>
                  <li>{this.props.content.statementPreferenceModalContent1}</li>
                  <li>{this.props.content.statementPreferenceModalContent2}</li>
                  {!isBOrVMRetail() && (
                    <li>
                      {this.props.content.statementPreferenceModalContent12}
                      <FaqAnyQuestionsLink
                        data={this.props.data}
                        content={this.props.content}
                        onClick={this.faqAnchorClick}
                      />
                    </li>
                  )}
                  <li>{this.props.content.statementPreferenceModalContent3}</li>
                  <li>{this.props.content.statementPreferenceModalContent4}</li>
                  <li>{this.props.content.statementPreferenceModalContent5}</li>
                  <li>{this.props.content.statementPreferenceModalContent6}</li>
                  {isBOrVMRetail() && (
                    <li>
                      {this.props.content.statementPreferenceModalContent12}
                      <FaqAnyQuestionsLink
                        data={this.props.data}
                        content={this.props.content}
                        onClick={this.faqAnchorClick}
                      />
                    </li>
                  )}
                  <li>{this.props.content.statementPreferenceModalContent7}</li>
                  <li>{this.props.content.statementPreferenceModalContent8}</li>
                </ul>
                <h5>{this.props.content.statementPrefernceModalHeader2}</h5>
                <ul>
                  <li>{this.props.content.statementPreferenceModalContent9}</li>
                  <li>
                    {this.props.content.statementPreferenceModalContent10}
                  </li>
                </ul>
                {agreementText}
              </div>
            ) : (
              <div ref="focusDiv" className="modalb-container">
                <h5>{this.props.content.statementPreferenceHelpHeader1}</h5>
                <p>{this.props.content.statementPreferenceHelpContent1}</p>
                <p>{this.props.content.statementPreferenceHelpContent2}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader2}</h5>
                <p>{this.props.content.statementPreferenceHelpContent3}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader3}</h5>
                <p>{this.props.content.statementPreferenceHelpContent4}</p>
                <p>
                  {this.props.content.statementPreferenceModalContent12}
                  <FaqAnyQuestionsLink
                    data={this.props.data}
                    content={this.props.content}
                    onClick={this.faqAnchorClick}
                  />
                </p>
                <h5>{this.props.content.statementPreferenceHelpHeader4}</h5>
                <p>{this.props.content.statementPreferenceHelpContent5}</p>
                <p>{this.props.content.statementPreferenceHelpContent6}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader5}</h5>
                <p>{this.props.content.statementPreferenceHelpContent7}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader6}</h5>
                <p>{this.props.content.statementPreferenceHelpContent8}</p>
                {agreementText}
              </div>
            )}
            <div className="modalb-footer">{displayButtons}</div>
          </div>
        </BasicModal>
      );
    } else {
      mobileDisplayPage = (
        <div className="main-container financial-stories2 account-1">
          <div ref="focusDiv" className="statement-info-modal">
            <div className="info-header">
              <div className="row no-gutters">
                {displayCancelButton}
                <div className="col-sm-8 col-xs-8 text-center">
                  <h5>{this.getModalHeader()}</h5>
                </div>
                <div className="col-sm-2 col-xs-2" />
              </div>
            </div>
            {this.props.continueButtonClick || isBOrVMRetail() ? (
              <div className="info-container">
                <h5>{this.props.content.statementPrefernceModalHeader1}</h5>
                <ul>
                  <li>{this.props.content.statementPreferenceModalContent1}</li>
                  <li>{this.props.content.statementPreferenceModalContent2}</li>
                  {!isBOrVMRetail() && (
                    <li>
                      {this.props.content.statementPreferenceModalContent12}
                      <FaqAnyQuestionsLink
                        data={this.props.data}
                        content={this.props.content}
                        onClick={this.faqAnchorClick}
                      />
                    </li>
                  )}
                  <li>{this.props.content.statementPreferenceModalContent3}</li>
                  <li>{this.props.content.statementPreferenceModalContent4}</li>
                  <li>{this.props.content.statementPreferenceModalContent5}</li>
                  <li>{this.props.content.statementPreferenceModalContent6}</li>
                  {isBOrVMRetail() && (
                    <li>
                      {this.props.content.statementPreferenceModalContent12}
                      <FaqAnyQuestionsLink
                        data={this.props.data}
                        content={this.props.content}
                        onClick={this.faqAnchorClick}
                      />
                    </li>
                  )}
                  <li>{this.props.content.statementPreferenceModalContent7}</li>
                  <li>{this.props.content.statementPreferenceModalContent8}</li>
                </ul>
                <h5>{this.props.content.statementPrefernceModalHeader2}</h5>
                <ul>
                  <li>{this.props.content.statementPreferenceModalContent9}</li>
                  <li>
                    {this.props.content.statementPreferenceModalContent10}
                  </li>
                </ul>
                {agreementText}
              </div>
            ) : (
              <div className="info-container">
                <h5>{this.props.content.statementPreferenceHelpHeader1}</h5>
                <p>{this.props.content.statementPreferenceHelpContent1}</p>
                <p>{this.props.content.statementPreferenceHelpContent2}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader2}</h5>
                <p>{this.props.content.statementPreferenceHelpContent3}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader3}</h5>
                <p>{this.props.content.statementPreferenceHelpContent4}</p>
                <p>
                  {this.props.content.statementPreferenceModalContent12}
                  <FaqAnyQuestionsLink
                    data={this.props.data}
                    content={this.props.content}
                    onClick={this.faqAnchorClick}
                  />
                </p>
                <h5>{this.props.content.statementPreferenceHelpHeader4}</h5>
                <p>{this.props.content.statementPreferenceHelpContent5}</p>
                <p>{this.props.content.statementPreferenceHelpContent6}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader5}</h5>
                <p>{this.props.content.statementPreferenceHelpContent7}</p>
                <h5>{this.props.content.statementPreferenceHelpHeader6}</h5>
                <p>{this.props.content.statementPreferenceHelpContent8}</p>
                {agreementText}
              </div>
            )}
            <div className="info-footer">{displayButtons}</div>
          </div>
        </div>
      );
    }
    return BrowserUtils.isMobileView() ? (
      <div>{mobileDisplayPage}</div>
    ) : (
      <div>{desktopDisplayPage}</div>
    );
  }
}

StatementPreferencesModal.propTypes = {
  content: PropTypes.object,
  helpModal: PropTypes.func,
  continueButtonClick: PropTypes.bool,
  _sendRequestPacket: PropTypes.func,
};

export default StatementPreferencesModal;
